import * as React from 'react';

import { useMounted } from '@hooks';

export function useAsyncSafeState<T>(initialState: T) {
  const isMounted = useMounted();
  const [value, setValue] = React.useState<T>(initialState);

  const asyncSafeSetValue = React.useCallback<typeof setValue>((newValue) => {
    if (isMounted.current) {
      return setValue(newValue);
    }
  }, []);

  return [value, asyncSafeSetValue] as const; // this as const was the key. https://github.com/microsoft/TypeScript/issues/35423
}
